import React from 'react';
import './Home.css';
import Instructions from './Instructions'; // Import the Instructions component

const Home = () => {
  // Images for the hero section (different from the grid below)
  const heroFigure1 = "/images/emoji1.png";
  const heroFigure2 = "/images/emoji2.png";
  
  // Images for the figures grid section
  const actionFigure1 = "/images/emoji3.png";
  const actionFigure2 = "/images/emoji8.png";
  const actionFigure3 = "/images/emoji5.png";
  const actionFigure4 = "/images/emoji9.png";
  
  // Prompts for the figure grid section
  const figurePrompts = [
    "Generate a mischievous emoji figure with vivid colors and playful expression in premium packaging",
    "Design a tech-savvy emoji with geometric details and futuristic accessories",
    "Create a cheerful emoji character with smooth curves and bright colors in collector's display box",
    "Craft a sophisticated emoji figure with subtle expressions and elegant collectible packaging"
  ];

  // Function to copy contract address to clipboard
  const copyAddress = () => {
    navigator.clipboard.writeText("5RqKVdyxpTWrDzMZKTzJvfoHzEQCCvMKmCXSdFzipump");
    alert("Contract address copied to clipboard!");
  };

  return (
    <div className="home">
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-images">
              <img src={heroFigure1} alt="Action Figure" />
              <img src={heroFigure2} alt="Action Figure" />
            </div>
            <div className="cta-container">
              <a href="#buy-now" className="buy-now-btn">Buy now</a>
              <h2>$MojiFi</h2>
            </div>
          </div>
        </div>
      </section>
      
      {/* Add the Instructions component here, below the hero section */}
      <div className="home-instructions">
        <Instructions />
      </div>

      <section id="buy-now" className="figures-section">
        <div className="container">
          <div className="figures-grid">
            {[actionFigure1, actionFigure2, actionFigure3, actionFigure4].map((img, index) => (
              <div key={index} className="figure-card">
                <img src={img} alt={`Action Figure ${index + 1}`} />
                <div className="figure-info">
                  <p className="figure-prompt">{figurePrompts[index]}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <h2>Contract address</h2>
          <div className="address-container">
            <p className="address">5RqKVdyxpTWrDzMZKTzJvfoHzEQCCvMKmCXSdFzipump</p>
            <button className="copy-btn" onClick={copyAddress}>Copy Address</button>
          </div>
          <h2>Get it now on</h2>
          <div className="exchange-links">
            <a href="https://dexscreener.com/solana/hqr7uz3ynvtja3riszwoyn8czbqvxqgqmqqkji5la262" target="_blank" rel="noopener noreferrer" className="exchange-btn">Dex Screener</a>
            <a href="https://pump.fun/coin/5RqKVdyxpTWrDzMZKTzJvfoHzEQCCvMKmCXSdFzipump" target="_blank" rel="noopener noreferrer" className="exchange-btn">Pump fun</a>
            <a href="https://photon-sol.tinyastro.io/en/lp/HQr7uZ3ynvtJa3riszWoYN8CZBQVXqGqmqqKJi5LA262?handle=12096317f9e81e0048bed4" target="_blank" rel="noopener noreferrer" className="exchange-btn">Photon</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 